import * as React from 'react';
import Svg, {Path} from 'react-native-svg';

interface IArrowStep1Props {
  color?: string;
}

function LocationIconDownArrow(props: IArrowStep1Props) {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      accessibilityLabel={'select location down arrow icon'}
    >
      <Path
        d="M11.203 18.797c.44.44 1.153.44 1.59 0l9.004-9a1.125 1.125 0 00-1.589-1.59l-8.203 8.204-8.208-8.208a1.125 1.125 0 00-1.59 1.59l8.996 9.004z"
        fill="#fff"
      />
    </Svg>
  );
}

export default LocationIconDownArrow;
